export default [
    {
        q: '꽃 주문은 어떻게 하나요?',
        a: `- 꽃이 필요한 날짜로부터 3-7일 전에 카카오톡으로 연락 주세요.
        취운화의 꽃은 주문 제작을 기반으로, 통상 준비와 제작에 3-7일이 소요됩니다.
        재료인 꽃 수급 상황에 따라 일정이 유동적일 수 있으니, 꼭 충분한 시간을 두고 주문 부탁 드립니다.`,
    }, 
    {
        q: `서울 수도권만 배송 가능한가요?`,
        a: `일반적으로 그렇습니다. 운반이 어려운 꽃의 특성상 장거리 운송이나 택배는 지원하지 않습니다.
        강남/성남 지역을 중심으로 차량 1-2시간 내외 냉장 운송이 가능한 거리를 대상으로 하고 있습니다.
        단, 취급 주문에 따라 대응 가능하니, 자세한 내용은 필히 문의 바랍니다.`
    },
    {
        q: `최소 주문 금액이 있나요?`,
        a: `취운화의 꽃은 주문 제작 방식이기 때문에 배송비 제외, 합산 7만원 이상 주문을 받고 있습니다.`
    },
    {
        q: `수업은 언제 시작하나요?`,
        a: `내 맴입니다.`
    },
    {
        q: `주문제작만 가능한가요?`,
        a: `네, 그렇습니다! 취운화는 현재 주문 제작만 받고 있습니다.`
    }

]